// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import arrowDownIcon from "@/assets/icons/arrow-down.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ArrowDownIconProps = Omit<IconProps, "name">;

export function ArrowDownIcon(props: ArrowDownIconProps): React.ReactNode {
  return <Icon name={arrowDownIcon} {...props} />;
}
